import React from "react";
import {
  Input
} from "@mui/material";
import PropTypes from "prop-types";

function DebounceInput(props) {
  const { handleChange, debounceTimeout, filterValue, setFilterValue, ...rest } = props;

  const timerRef = React.useRef();

  const handleChangeDebounced = async (event) => {
    setFilterValue(event.target.value);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(async () => handleChange(event), debounceTimeout);
  };

  return <Input {...rest} onChange={handleChangeDebounced} value={filterValue} />;
}

DebounceInput.propTypes = {
  debounceTimeout: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  filterValue: PropTypes.string.isRequired,
  setFilterValue: PropTypes.func.isRequired,
};

export default DebounceInput;